import React from 'react';
import type { ViewProps } from 'react-native';
import { View } from 'react-native';
import type { AddressType } from '@sweetgreen/garnish';
import { ListActionSwitch, SectionHeader } from '@sweetgreen/garnish';

import { useLocalizationContext } from '@order/Localization';

import { CheckoutLayoutBlock } from '../../CheckoutLayout';

export const CheckoutExtrasBlock = ({
  onIncludeUtensilsToggle,
  includeUtensils,
  orderType,
  ...rest
}: CheckoutExtrasBlockProps) => {
  const { t } = useLocalizationContext();
  const heading = t(`general.extras`);

  if (orderType !== 'delivery') return null;

  return (
    <CheckoutLayoutBlock {...rest}>
      <SectionHeader heading={heading} />
      <UtensilsSelector
        includeUtensils={includeUtensils}
        onIncludeUtensilsToggle={onIncludeUtensilsToggle}
      />
    </CheckoutLayoutBlock>
  );
};

export const UtensilsSelector = ({
  includeUtensils,
  onIncludeUtensilsToggle,
}: UtensilsSelectorProps) => {
  const { t } = useLocalizationContext();

  return (
    <View>
      <ListActionSwitch
        title={t('checkout.extras.utensils-title')}
        text={t('checkout.extras.utensils-description')}
        value={includeUtensils}
        onChange={onIncludeUtensilsToggle}
        testID="checkout.extras.utensils-toggle"
      />
    </View>
  );
};

type CheckoutExtrasBlockProps = {
  readonly orderType: AddressType;
} & Omit<ViewProps, 'children'> &
  UtensilsSelectorProps;

type UtensilsSelectorProps = {
  readonly onIncludeUtensilsToggle: () => void;
  readonly includeUtensils: boolean;
};
